import React, { MouseEvent, useState } from "react";

import IconButton from "@material-ui/core/IconButton";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";

import { useRacehorse360Api } from "hooks/api";
import CommentsPopover from "../../CommentsPopover";
import { IPopoverItem } from "../../CommentsPopover/CommentsPopover";

import useStyles from "./styles";

interface IProps {
  onCommentIconClick?: (event: MouseEvent<HTMLElement>) => void;
  flagOnTrackCommentId: string;
}

const FlagOnTrack = (props: IProps) => {
  const { flagOnTrackCommentId } = props;

  const classes = useStyles();

  const [anchorElement, setAnchorElement] = useState<HTMLElement>(null);

  const { useGetHorseFlagOnTrackComment } = useRacehorse360Api();

  const {
    data: horseFlagOnTrackComment,
    isLoading: isFlagOnTrackCommentLoading
  } = useGetHorseFlagOnTrackComment(
    {
      id: flagOnTrackCommentId,
      getOptions: {
        select: ["updatedOn", "updatedBy", "body"]
      }
    },
    {
      enabled: [anchorElement, flagOnTrackCommentId].every(Boolean)
    }
  );

  const commentData: IPopoverItem = {
    id: horseFlagOnTrackComment?.id,
    updatedBy: horseFlagOnTrackComment?.updatedBy,
    updatedOn: horseFlagOnTrackComment?.updatedOn,
    body: horseFlagOnTrackComment?.body
  };

  const handleOpenCommentsPopover = event => {
    setAnchorElement(event.target);
  };

  const handleCloseCommentsPopover = () => {
    setAnchorElement(null);
  };

  return (
    <>
      <span className={classes.FOT}>FOT</span>
      <IconButton
        size={"small"}
        className={classes.FOTButton}
        onClick={handleOpenCommentsPopover}
      >
        <ChatOutlinedIcon className={classes.FOT} />
      </IconButton>
      {Boolean(anchorElement) && (
        <CommentsPopover
          anchorElement={anchorElement}
          onClose={handleCloseCommentsPopover}
          isLoadingData={isFlagOnTrackCommentLoading}
          data={commentData}
        />
      )}
    </>
  );
};

export default React.memo(FlagOnTrack);
